import React, { createContext, useContext, useEffect, useState } from 'react';
import { COMMISSION_RATE } from '../mock';

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const saved = localStorage.getItem('tokengate_cart');
      return saved ? JSON.parse(saved) : [];
    } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('tokengate_cart', JSON.stringify(items));
  }, [items]);

  const addItem = (item) => {
    setItems((prev) => {
      const key = `${item.brandId}-${item.denomination}-${item.country}`;
      const existing = prev.find(p => p.key === key);
      if (existing) {
        return prev.map(p => p.key === key ? { ...p, quantity: p.quantity + item.quantity } : p);
      }
      return [...prev, { ...item, key, id: Date.now().toString() }];
    });
  };

  const removeItem = (key) => setItems((prev) => prev.filter(p => p.key !== key));
  const updateQty = (key, quantity) => setItems((prev) => prev.map(p => p.key === key ? { ...p, quantity: Math.max(1, quantity) } : p));
  const clearCart = () => setItems([]);

  // Gift-card face value total (what user redeems)
  const faceTotal = items.reduce((sum, it) => sum + it.denomination * it.quantity, 0);
  // 10% TokenGate service fee (our commission)
  const serviceFee = +(faceTotal * COMMISSION_RATE).toFixed(2);
  // Amount user actually pays in crypto
  const total = +(faceTotal + serviceFee).toFixed(2);
  const count = items.reduce((sum, it) => sum + it.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clearCart, faceTotal, serviceFee, total, count }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
